/**
 * weekly-multi-channel-viewing-summary
 *
 * @author    Alexis Vedia <alexis.vedia@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules
import weeklyPeriodSelectsFactory from "./viewing-summary/weekly-period-selects";
import weeklyViewingSummary from "./viewing-summary/weekly-viewing-summary";
import commonFormSend from "./vr-reports/common-form-send";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule(
    "periodSelects",
    weeklyPeriodSelectsFactory("/resources/viewing-multi-channel-summary-available-weeks")
);
core.createModule(
    "weekly_summary",
    weeklyViewingSummary("/resources/tv-facts/total-weekly-multi-channel-summary-92-09")
);

core.createModule("commonFormSend", commonFormSend);
core.startAll();
